'use client';
import { jsx } from 'react/jsx-runtime';
import { useRef } from 'react';
import { PopoverContentInternal } from '../popover/popover-content-internal.component.js';
import { useDeprecatedProps } from '../../hooks/use-deprecated-props.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { useSwanPopover } from '../popover/popover.context.js';
import { assignRefs } from '../../../core/utilities/ref.utils.js';
import { RenderComp } from '../core/render-comp.component.js';

function _define_property(e, r, t) {
    return r in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[r] = t, e;
}
function _object_spread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {}, o = Object.keys(t);
        "function" == typeof Object.getOwnPropertySymbols && (o = o.concat(Object.getOwnPropertySymbols(t).filter(function(e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
        }))), o.forEach(function(r) {
            _define_property(e, r, t[r]);
        });
    }
    return e;
}
function _object_without_properties(e, r) {
    if (null == e) return {};
    var t, o, n = _object_without_properties_loose(e, r);
    if (Object.getOwnPropertySymbols) {
        var p = Object.getOwnPropertySymbols(e);
        for(o = 0; o < p.length; o++)t = p[o], !(r.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(e, t) && (n[t] = e[t]);
    }
    return n;
}
function _object_without_properties_loose(e, r) {
    if (null == e) return {};
    var t, o, n = {}, p = Object.keys(e);
    for(o = 0; o < p.length; o++)t = p[o], r.indexOf(t) >= 0 || (n[t] = e[t]);
    return n;
}
const MenuPopover = renderWithRef('MenuPopover', {}, (n, a)=>{
    useDeprecatedProps('MenuPopover', n, [
        {
            propName: 'labelText',
            instructions: 'This is deprecated without a replacement.'
        }
    ]);
    let { children: s, className: l, placement: u = 'bottom start', hideArrow: m = true } = n, f = _object_without_properties(n, [
        "children",
        "className",
        "placement",
        "hideArrow"
    ]), { overlayState: b } = useSwanPopover(), d = assignRefs(a, useRef(null)), _ = new Set([
        'swan-menu-popover',
        'swan-listbox-popover'
    ]);
    return l && _.add(l), b.isOpen ? jsx(RenderComp, {
        root: PopoverContentInternal,
        forwardedRef: d,
        classNames: _,
        props: _object_spread({
            placement: u,
            hideArrow: m,
            disableContainerPadding: true
        }, f),
        children: s
    }) : jsx("div", {
        "aria-hidden": "true",
        className: "swan-display-none",
        children: s
    });
});

export { MenuPopover };
